export { PointOfInterestsList } from './PointOfInterestsList';
